/**
 * Universal auth plugin — restores user state from cookie on both SSR and client.
 *
 * On SSR: fetches user profile from backend, state is serialized to client via payload.
 * On client: only fetches if SSR didn't populate the state (fallback for SSR failures).
 */
export default defineNuxtPlugin(async () => {
  const { initAuth } = useAuth()
  await initAuth()
})
